import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../axios";

// Блок «О нас»: текст компании, преимущества и цифры. Живёт в настройках
// сайта (ключ `about`), правится в админке. Если бэкенд недоступен —
// остаёмся на пустом объекте, и секция просто не рисуется.
export const fetchAbout = createAsyncThunk("about/fetch", async () => {
    const { data } = await axios.get("/settings/about");
    return data;
});

export const saveAbout = createAsyncThunk("about/save", async (about) => {
    const { data } = await axios.put("/settings/about", about);
    return data;
});

const EMPTY = { title: {}, text: {}, advantages: [], stats: [] };

const aboutSlice = createSlice({
    name: "about",
    initialState: { data: EMPTY, status: "idle" },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAbout.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchAbout.fulfilled, (state, action) => {
                state.data = { ...EMPTY, ...action.payload };
                state.status = "loaded";
            })
            .addCase(fetchAbout.rejected, (state) => {
                state.status = "error";
            })
            .addCase(saveAbout.fulfilled, (state, action) => {
                state.data = { ...EMPTY, ...action.payload };
                state.status = "loaded";
            });
    },
});

// Есть ли в блоке хоть что-то, кроме заголовка. Нужен и самой секции, и
// главной странице: если показывать нечего, между соседними блоками не должно
// оставаться ни секции, ни разделителя — иначе на странице зияет пустота
// между двумя ветками подряд.
export const selectAboutHasContent = (state) => {
    const data = state.about.data;
    const text = data?.text || {};
    return (
        Object.values(text).some(Boolean) ||
        (data?.advantages?.length || 0) > 0 ||
        (data?.stats?.length || 0) > 0
    );
};

export const aboutReducer = aboutSlice.reducer;
